import type { SVGProps } from "react";
export interface HammerIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function HammerIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: HammerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M10.58 9.36a1.125 1.125 0 0 1 1.504-.08l.087.077 2.528 2.517.078.085a1.125 1.125 0 0 1-1.58 1.586l-.084-.077-2.53-2.517-.078-.085a1.126 1.126 0 0 1 .075-1.506"
      />
      <path
        fill={color}
        d="M6.387 2.977c3.221-2.896 8.193-2.8 11.297.289l3.592 3.574c.212.211.331.499.331.798v1.166l.166.25a1.124 1.124 0 0 1 1.02 1.898l-.185-.188v.002l.186.186-3.036 3.019-.084.077a1.126 1.126 0 0 1-1.813-1.095l-.243-.161a11 11 0 0 0-1.57.123c-.653.11-1.044.28-1.225.427l-.064.063-7.245 8.41a3.783 3.783 0 0 1-5.228.48l-.302-.27a3.75 3.75 0 0 1 .21-5.519l8.453-7.208c.272-.232.455-.614.546-1.226l.01-.11c.023-.56-.4-1.211-1.195-1.499l-3.566-1.29a1.128 1.128 0 0 1-.412-1.856l.051-.051zm9.71 1.884a5.99 5.99 0 0 0-6.92-1.091l1.596.577.289.117c1.334.599 2.467 1.937 2.392 3.584l-.035.358c-.13.863-.45 1.87-1.312 2.604l-8.452 7.21a1.5 1.5 0 0 0-.084 2.21c.63.627 1.662.587 2.239-.083l7.245-8.41.135-.145c.696-.696 1.723-.966 2.487-1.094.88-.148 1.764-.158 2.278-.158l.164.013c.162.024.319.083.457.174l.753.5.715-.712-.495-.74a1.13 1.13 0 0 1-.191-.627V8.104z"
      />
    </svg>
  );
}
